
export const receipeActionCreator = (recipe) => ({
    type: 'RECIPE',
    payload: recipe,
  });

 